// Company Information
export const COMPANY_INFO = {
  name: 'Rishant Technologies',
  fullName: 'Rishant Technologies Pvt Ltd',
  tagline: 'AI Automation for Indian Businesses',
  website: 'rishant.tech',
  // TODO: Replace with real WhatsApp number
  whatsapp: '+91XXXXXXXXXX',
  whatsappUrl: 'https://wa.me/91XXXXXXXXXX',
  email: 'hello@rishant.tech',
  // TODO: Replace with real Calendly link
  calendlyUrl: 'https://calendly.com/rishant-tech',
  // TODO: Add real CIN number in footer
  cin: 'CIN: XXXXXXXXXXXXXXX',
  responseTime: 'We reply within 4 business hours'
};

// Navigation Links
export const NAV_LINKS = [
  { name: 'Home', path: '/' },
  { name: 'Services', path: '/services' },
  { name: 'How It Works', path: '#how-it-works' },
  { name: 'Industries', path: '#industries' },
  { name: 'About', path: '/about' },
  { name: 'Health', path: '/health' },
  { name: 'Contact', path: '/contact' }
];

// Services Data
export const SERVICES = [
  {
    id: 'whatsapp-automation',
    icon: 'WhatsApp',
    title: 'WhatsApp Business Automation',
    description: '24/7 automated replies, lead capture, appointment booking, payment reminders — all on WhatsApp. Your customers never wait. Your staff focus on real work.',
    features: [
      'Automated customer support',
      'Lead capture and qualification',
      'Appointment booking',
      'Payment reminders',
      'Broadcast messaging',
      'Multi-language support'
    ],
    pricing: {
      setup: '₹15,000',
      monthly: '₹5,000'
    },
    popular: true,
    tag: 'Most Popular'
  },
  {
    id: 'ai-support',
    icon: 'Robot',
    title: 'AI-Powered Customer Support',
    description: 'Train an intelligent bot on your FAQs, products, and policies. It handles 80% of queries instantly. Escalates complex ones to humans automatically.',
    features: [
      'Intelligent FAQ automation',
      'Product information queries',
      'Order status updates',
      'Smart escalation',
      'Learning from interactions',
      'Analytics and insights'
    ],
    pricing: {
      setup: '₹20,000',
      monthly: '₹8,000'
    }
  },
  {
    id: 'lead-generation',
    icon: 'Target',
    title: 'Automated Lead Generation',
    description: 'Capture, qualify, score, and follow up with leads automatically. Get notified only when a lead is ready to buy. Stop chasing, start closing.',
    features: [
      'Lead capture forms',
      'Automatic qualification',
      'Lead scoring',
      'Follow-up sequences',
      'CRM integration',
      'Sales pipeline management'
    ],
    pricing: {
      setup: '₹30,000',
      monthly: '₹10,000'
    }
  },
  {
    id: 'process-automation',
    icon: 'Cog',
    title: 'End-to-End Process Automation',
    description: 'Quotations, invoices, reminders, reports — auto-generated from templates. Eliminate repetitive manual tasks across your entire operation.',
    features: [
      'Document automation',
      'Workflow optimization',
      'Report generation',
      'Task scheduling',
      'System integrations',
      'Custom dashboards'
    ],
    pricing: {
      setup: '₹20,000',
      monthly: '₹7,000'
    }
  }
];

// Industries Data
export const INDUSTRIES = [
  {
    id: 'education',
    name: 'Coaching & Education',
    description: 'Automate admissions, fee reminders, student queries, and batch notifications.',
    icon: 'GraduationCap',
    automations: [
      'Student inquiry management',
      'Fee payment reminders',
      'Class schedules and updates',
      'Admission process automation',
      'Parent communication',
      'Result notifications'
    ]
  },
  {
    id: 'real-estate',
    name: 'Real Estate',
    description: 'Capture property enquiries, qualify buyers, schedule site visits — all on auto-pilot.',
    icon: 'Building',
    automations: [
      'Lead capture from portals',
      'Property recommendation',
      'Site visit scheduling',
      'Document collection',
      'Follow-up sequences',
      'Market updates'
    ]
  },
  {
    id: 'healthcare',
    name: 'Healthcare & Clinics',
    description: 'Appointment booking, reminders, patient follow-ups, prescription alerts.',
    icon: 'Heart',
    automations: [
      'Appointment scheduling',
      'Patient reminders',
      'Medical history collection',
      'Prescription notifications',
      'Health tips and updates',
      'Emergency contact system'
    ]
  },
  {
    id: 'ecommerce',
    name: 'D2C & E-Commerce',
    description: 'Order updates, return requests, product queries, abandoned cart recovery.',
    icon: 'ShoppingCart',
    automations: [
      'Order status updates',
      'Product recommendations',
      'Cart abandonment recovery',
      'Customer feedback collection',
      'Inventory notifications',
      'Support ticket management'
    ]
  },
  {
    id: 'marketing',
    name: 'Marketing Agencies',
    description: 'Client reporting, lead delivery, WhatsApp campaign automation at scale.',
    icon: 'TrendingUp',
    automations: [
      'Campaign performance reports',
      'Lead distribution',
      'Client communication',
      'Social media scheduling',
      'ROI tracking',
      'Proposal automation'
    ]
  },
  {
    id: 'finance',
    name: 'Finance & Insurance',
    description: 'Lead qualification, document collection reminders, policy renewal alerts.',
    icon: 'CreditCard',
    automations: [
      'Application processing',
      'Document verification',
      'Premium reminders',
      'Policy renewals',
      'Claims processing',
      'Investment updates'
    ]
  }
];

// Statistics for Social Proof
export const STATS = [
  {
    id: 'automations',
    number: 50,
    suffix: '+',
    label: 'Automations Deployed',
    icon: 'Zap'
  },
  {
    id: 'setup-time',
    number: 5,
    suffix: ' Days',
    label: 'Average Setup',
    icon: 'Clock'
  },
  {
    id: 'query-reduction',
    number: 80,
    suffix: '%',
    label: 'Query Reduction',
    icon: 'TrendingDown'
  },
  {
    id: 'industries',
    number: 12,
    suffix: '+',
    label: 'Industries Served',
    icon: 'Building'
  }
];

// Testimonials
export const TESTIMONIALS = [
  {
    id: 1,
    // TODO: Add real client testimonials and names
    quote: "Before Rishant, we had 2 staff handling WhatsApp enquiries full time. Now the bot handles everything and our admissions team focuses on converting, not replying.",
    author: "Client Name",
    position: "Coaching Institute Owner",
    location: "Bangalore",
    rating: 5,
    industry: 'education'
  },
  {
    id: 2,
    // TODO: Add real client testimonials and names
    quote: "We were losing leads because we couldn't reply fast enough. Now our response time is under 30 seconds, 24/7. Our closing rate improved by 40%.",
    author: "Client Name",
    position: "Real Estate Broker",
    location: "Mumbai",
    rating: 5,
    industry: 'real-estate'
  },
  {
    id: 3,
    // TODO: Add real client testimonials and names
    quote: "Patient appointment reminders used to be a daily manual task. It's now fully automated and our no-show rate dropped by 60%.",
    author: "Client Name",
    position: "Clinic Owner",
    location: "Hyderabad",
    rating: 5,
    industry: 'healthcare'
  }
];

// How It Works Steps
export const HOW_IT_WORKS_STEPS = [
  {
    id: 1,
    title: 'Automation Audit',
    subtitle: 'Free, 20 min',
    description: 'We map your current workflow, find the bottlenecks, and identify what can be automated immediately.',
    icon: 'Search',
    isFree: true
  },
  {
    id: 2,
    title: 'Custom Blueprint',
    description: 'We design the exact automation system for your business — no templates, no generic solutions.',
    icon: 'FileText'
  },
  {
    id: 3,
    title: 'Build & Test',
    description: 'We build, configure, and rigorously test your system. You see it working before it goes live.',
    icon: 'Settings'
  },
  {
    id: 4,
    title: 'Go Live + Support',
    description: 'We deploy and monitor. Monthly support retainer keeps everything running and improving.',
    icon: 'Rocket'
  }
];

// Problem Section Data
export const PROBLEMS = [
  {
    id: 1,
    icon: 'MessageCircle',
    title: 'Drowning in WhatsApp Messages',
    description: 'Your team spends hours manually replying to the same questions. Leads go cold. Staff burn out. Opportunities vanish.'
  },
  {
    id: 2,
    icon: 'Clock',
    title: 'Slow Response = Lost Revenue',
    description: 'Indian customers expect replies within minutes. Every hour of delay costs you 60% of that lead. Your competitor replies in 30 seconds.'
  },
  {
    id: 3,
    icon: 'AlertTriangle',
    title: 'Manual Processes at Scale Don\'t Work',
    description: 'Copy-pasting, spreadsheets, forwarding messages. Your business can\'t grow if your team is a human relay race.'
  }
];

// Values
export const VALUES = [
  {
    id: 1,
    name: 'India-First',
    description: 'Built for how Indian businesses actually operate'
  },
  {
    id: 2,
    name: 'No Jargon',
    description: 'Plain language, clear explanations, honest pricing'
  },
  {
    id: 3,
    name: 'Results-Guaranteed',
    description: 'You see the automation working before you pay'
  }
];

// Form Options
export const FORM_OPTIONS = {
  industries: [
    'Education/Coaching',
    'Real Estate',
    'Healthcare/Clinic',
    'D2C/E-commerce',
    'Marketing Agency',
    'Finance/Insurance',
    'Other'
  ],
  sources: [
    'Google Search',
    'WhatsApp/Social Media',
    'Referral',
    'LinkedIn',
    'Industry Event',
    'Other'
  ]
};

// Social Proof Micro Stats
export const HERO_SOCIAL_PROOF = [
  {
    text: '50+ Automations Built',
    icon: 'Zap'
  },
  {
    text: '₹0 Extra Staff Cost for Clients',
    icon: 'DollarSign'
  },
  {
    text: 'Setup in 5 Days',
    icon: 'Calendar'
  }
];

// Footer Links
export const FOOTER_LINKS = {
  services: [
    { name: 'WhatsApp Automation', path: '/services#whatsapp' },
    { name: 'AI Customer Support', path: '/services#ai-support' },
    { name: 'Lead Generation', path: '/services#lead-gen' },
    { name: 'Process Automation', path: '/services#process' }
  ],
  company: [
    { name: 'About Us', path: '/about' },
    { name: 'How It Works', path: '/#how-it-works' },
    { name: 'Industries', path: '/#industries' },
    { name: 'Contact', path: '/contact' },
    { name: 'Privacy Policy', path: '/privacy' },
    { name: 'Terms of Service', path: '/terms' }
  ],
  contact: [
    { name: 'WhatsApp', url: COMPANY_INFO.whatsappUrl, external: true },
    { name: 'Email', url: `mailto:${COMPANY_INFO.email}`, external: true },
    { name: 'Book a Call', url: COMPANY_INFO.calendlyUrl, external: true }
  ]
};

// Social Media Links
export const SOCIAL_LINKS = [
  {
    name: 'LinkedIn',
    icon: 'Linkedin',
    url: 'https://linkedin.com/company/rishant-tech' // TODO: Replace with real LinkedIn URL
  },
  {
    name: 'Instagram',
    icon: 'Instagram',
    url: 'https://instagram.com/rishant_tech' // TODO: Replace with real Instagram URL
  },
  {
    name: 'YouTube',
    icon: 'Youtube',
    url: 'https://youtube.com/@rishant-tech' // TODO: Replace with real YouTube URL
  }
];

// Animation variants for Framer Motion
export const ANIMATION_VARIANTS = {
  fadeInUp: {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: 'easeOut' }
  },
  staggerContainer: {
    animate: {
      transition: {
        staggerChildren: 0.15
      }
    }
  },
  slideInLeft: {
    initial: { opacity: 0, x: -30 },
    animate: { opacity: 1, x: 0 },
    transition: { duration: 0.6, ease: 'easeOut' }
  },
  slideInRight: {
    initial: { opacity: 0, x: 30 },
    animate: { opacity: 1, x: 0 },
    transition: { duration: 0.6, ease: 'easeOut' }
  },
  scaleIn: {
    initial: { opacity: 0, scale: 0.9 },
    animate: { opacity: 1, scale: 1 },
    transition: { duration: 0.6, ease: 'easeOut' }
  }
};